'use client';
import React from 'react';

// interface AboutHeroProps {
//   containerVariants: any;
//   itemVariants: any;
// }

export const AboutHero: React.FC = () => (
  <div
    className="relative w-full h-[50vh] md:h-[60vh] lg:h-[70vh] bg-cover bg-center flex items-center justify-center text-center px-4"
    style={{
      backgroundImage: `url(https://images.unsplash.com/photo-1600684249816-38cdfcf95c17?q=80&w=873&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)`, // Placeholder for a road/industrial background
      backgroundAttachment: 'fixed',
    }}
  >
    <div className="absolute inset-0 bg-black opacity-60"></div>
    <div className="relative z-10 max-w-3xl">
      <p className="text-yellow-400 text-lg md:text-xl font-medium mb-2">
        Delivering excellence through tailored industrial solutions
      </p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight mb-4" >
        Your Trusted Partner for Industrial and Engineering Products
      </h1>
      <p className="text-lg sm:text-xl text-gray-300" >
        Innovation & a Talented Team
      </p>
    </div>
  </div>
);